import React from 'react';
import { useHistory } from 'react-router-dom';
import { Typography } from '@mui/material';
import Button from '../Button';
import { useStyles } from './ErrorPage.styles';

type Props = {
  title: string | null | undefined;
  message: string | null | undefined;
};

export const ErrorPageUnconnected = ({ title, message }: Props) => {
  const history = useHistory();
  const classes = useStyles();
  const pushHome = React.useCallback(() => {
    history.push('/');
  }, [history]);

  return (
    <div className={classes.root}>
      <Typography variant="h4">{title || 'Error'}</Typography>
      <Typography variant="body1">{message || 'Something went wrong'}</Typography>
      <Button
        onClick={pushHome}
        color="primary"
        variant="contained"
        classsName={classes.btn}
        label={{ key: 'text.no.translation', context: { value: 'Go to Home' } }}
      />
    </div>
  );
};

export default ErrorPageUnconnected;
